exports.components = {
  "component---src-components-programs-list-program-list-page-jsx": () => import("./../../../src/components/programs-list/ProgramListPage.jsx" /* webpackChunkName: "component---src-components-programs-list-program-list-page-jsx" */)
}

